import { SchemaForm } from "./component";
import { DefaultPropsTypeCheck } from "../default.props";
SchemaForm.propTypes = Object.assign({}, DefaultPropsTypeCheck);
export { SchemaForm };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/fx-schema-form-react/libs/components/form/index.js
// module id = 85
// module chunks = 3